export const categories = [
  { id: 1, name: '明星黑料', slug: 'mingxing-heiliao', icon: 'ri-star-smile-line', articleCount: 128 },
  { id: 2, name: '网红爆料', slug: 'wanghong-baoliao', icon: 'ri-live-line', articleCount: 96 },
  { id: 3, name: '影视八卦', slug: 'yingshi-bagua', icon: 'ri-movie-2-line', articleCount: 87 },
  { id: 4, name: '综艺翻车', slug: 'zongyi-fanche', icon: 'ri-tv-2-line', articleCount: 64 },
  { id: 5, name: '音乐圈乱象', slug: 'yinyuequan-luanxiang', icon: 'ri-music-2-line', articleCount: 53 },
  { id: 6, name: '直播带货瓜', slug: 'zhibo-daihuogua', icon: 'ri-shopping-bag-3-line', articleCount: 72 },
  { id: 7, name: '体育圈内幕', slug: 'tiyuquan-neimu', icon: 'ri-football-line', articleCount: 41 },
  { id: 8, name: '电竞风云', slug: 'dianjing-fengyun', icon: 'ri-gamepad-line', articleCount: 58 },
];